import React, { useEffect, useState } from "react";
import axios from "axios";
import SendOtp from "../../components/modal/SendOtp/SendOtp";
import PopPageValidateOtp from "../../components/modal/ValidateOtp/ValidateOtp";
import ButtonCommon from "../../components/button-common/ButtonCommon";
import useGetGovernorRate from "../../hooks/useGetGoverner";
import { GovernorateArray, NCD_API_TOKEN } from "../../shared/commonUtils";
import { CelebrationSvg } from "../../assets/svgs/svgs";
import useTranslationHook from "../../hooks/useTranslationHook";
import {
  BarcodeScanner,
  BarcodeReaderModule,
} from "dynamsoft-barcode-reader-bundle";
import ScannerModal from "./components/ScannerModal/ScannerModal";
import OverlayLoader from "../../components/overlayLoader/OverlayLoader";
import { useTranslation } from "react-i18next";
import { showErrortMessage } from "../../shared/helpersMethod";
const governorates = GovernorateArray;
const BarcodeScanComponent = () => {
  const { t } = useTranslation();
  const [barcode, setBarcode] = useState("");
  const [error, setError] = useState("");
  const [isEligible, setIsEligible] = useState(false);
  const [isVerified, setIsVerified] = useState<boolean>(false);
  const [showValidateOtpModal, setShowOtpValidate] = useState<boolean>(false);
  const [showValidateModal, setShowValidate] = useState<boolean>(false);
  const [showScanner, setShowScanner] = useState<boolean>(false);
  const DynamSoftKey =
    "DLS2eyJoYW5kc2hha2VDb2RlIjoiMTAzNjM4Mjc2LVRYbFhaV0pRY205cSIsIm1haW5TZXJ2ZXJVUkwiOiJodHRwczovL21kbHMuZHluYW1zb2Z0b25saW5lLmNvbSIsIm9yZ2FuaXphdGlvbklEIjoiMTAzNjM4Mjc2IiwiY2hlY2tDb2RlIjotNTIyOTc4ODA1fQ==";
  const [loading, setLoading] = useState(false);
  const [customerMobile, setCustomerMobile] = useState<string>("");
  const [userCountryCode, setCountryCode] = useState<string>("");
  const { getGovernorRate, governorData } = useGetGovernorRate();
  const [otpReqId, setOtpReqId] = useState<string>("");
  const [success, setSuccess] = useState<boolean>(false);
  const [formData, setFormData] = useState({
    name: "",
    invoice: null,
    governorate: "",
    address: "",
    // area: "",
    // street: "",
    mobile: customerMobile,
  });
  var barcodeScanner: BarcodeScanner | undefined = undefined;
  const [previewUrl, setPreviewUrl] = useState(null);
  const [fileType, setFileType] = useState("");

  const handleChange = (e) => {
    const { name, value, files } = e.target;

    if (name === "invoice" && files && files[0]) {
      const file = files[0];
      setFormData((prev) => ({
        ...prev,
        invoice: file,
      }));

      const fileExt = file.name.split(".").pop().toLowerCase();
      setFileType(fileExt);

      const url = URL.createObjectURL(file);
      setPreviewUrl(url);
    } else {
      console.log(value);
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const data = new FormData();
    data.append("name", formData.name);
    data.append("invoice", formData.invoice);
    data.append("governorate", formData.governorate);

    console.log("Submitting:", formData);

    submitFreeInstallRequest();
    // axios.post('/api/submit-form', data)
  };
  const submitFreeInstallRequest = async () => {
    try {
      const formDataFinal = new FormData();
      formDataFinal.append("mobile", customerMobile);
      formDataFinal.append("name", formData.name);
      formDataFinal.append("serialnumber", barcode);
      formDataFinal.append("street", "N/A");
      formDataFinal.append("area", "N/A");
      formDataFinal.append("governerate", formData.governorate);
      formDataFinal.append("address", formData.address);

      // Replace with actual file object from input (e.g., from file input in form)
      // const fileInput = document.querySelector("#receiptInput");
      formDataFinal.append("receipt", formData.invoice);
      const response = await axios.post(
        "https://postsales.ncd.iq/api/appapis/adhock/freeinstall/submitFreeInstallReq",
        formDataFinal,
        {
          headers: {
            Authorization: `Bearer ${NCD_API_TOKEN}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );

      console.log("Success:", response.data);
      if (response.data.type === "success") {
        setSuccess(true);
      } else {
        showErrortMessage("حدث خطأ ما، يرجى المحاولة مرة أخرى.", 2000);
      }
    } catch (error) {
      console.error("Error:", error.response?.data || error.message);
      showErrortMessage("حدث خطأ ما، يرجى المحاولة مرة أخرى.", 2000);
    }
  };
  const handleScan = async (barcode: string) => {
    //Open Dynamsoft model for scanning and bring barcode int variable
    try {
      setLoading(true);
      setError("");
      // const scannedCode = prompt("free_install_lbl_enter_barcode"); // Replace with real scanner
      // if (!scannedCode) return;

      setBarcode(barcode);
      // https://postsales.ncd.iq/api/inbound/getGovernorates
      const response = await axios.post(
        "https://postsales.ncd.iq/api/appapis/adhock/freeinstall/chkEligibleForFreeInstall",
        {
          sNo: barcode, // replace with actual serial number dynamically if needed
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${NCD_API_TOKEN}`, // replace with actual token
          },
        }
      );
      console.log("chkEligibleForFreeInstall : ");

      console.log(response);
      if (response.data[0].errorcode == 0) {
        setIsEligible(true);
        showValidateModalHandler();
        hideScanner();
      } else {
        setIsEligible(true);
        showValidateModalHandler();
        setIsEligible(false);
        setError(t("free_install_lbl_noteligible_for_install"));
      }
    } catch (err) {
      setIsEligible(true);
      showValidateModalHandler();
      setError("Failed to validate barcode. Please try again.");
    } finally {
      setLoading(false);
    }
  };
  const showValidateOtpModalHandler = () => {
    setShowOtpValidate(true);
  };
  const onRequestSendOtpClose = (countryCode: any, otpReqId: string) => {
    setShowValidate(false);
    if (otpReqId) {
      setOtpReqId(otpReqId);
    }
    if (countryCode !== null) {
      showValidateOtpModalHandler();
      setCountryCode(countryCode);
    }
  };
  const onRequestValidateOtpModalClose = () => {
    setShowOtpValidate(false);
    showValidateModalHandler();
  };
  const showValidateModalHandler = () => {
    setShowValidate(true);
  };
  const onSuccessValidateOtp = (isNew: any, customerData: IOTPCUSTRES) => {
    setShowOtpValidate(false);
    setShowValidate(false);
    setIsVerified(true);
  };
  const showBarcodeHandler = () => {
    setShowScanner(true);
  };
  const hideScanner = () => {
    setShowScanner(false);
  };

  useEffect(() => {
    getGovernorRate();
  }, []);
  return (
    <div style={{ padding: 20 }}>
      {/* Banner */}
      <OverlayLoader loading={loading} />
      {/* This div will host the barcode scanner's camera view */}

      {showScanner && (
        <ScannerModal
          showScanner={showScanner}
          onPressClose={() => {
            //
            // handleScan("AABX4JE0000N2Q7H0214");
            hideScanner();
          }}
          onScanBarcode={(value) => {
            //

            setBarcode(value);
            handleScan(value);
            hideScanner();
          }}
        />
      )}
      {/* Scan Button */}
      {!isEligible && (
        // <div className="row justify-content-center">
        //   <div className="col-md-6 col-lg-5">
        //     <ButtonCommon
        //       btnLabelText={t("free_install_btn_scan_qr")}
        //       onPressButton={showBarcodeHandler}
        //     />
        //   </div>
        // </div>
        <div class="text-center mt-4">
          <button
            style={{ backgroundColor: "var(--button-color)" }}
            onClick={showBarcodeHandler}
            class="btn btn-dark btn-lg rounded-pill px-5 shadow"
          >
            <i class="bi bi-qr-code-scan me-2"></i>
            {t("free_install_btn_scan_qr")}
          </button>
          <small class="text-muted d-block mt-2">
            استخدم كاميرا هاتفك لمسح الرمز
          </small>
        </div>
        // <button onClick={handleScan} disabled={loading}>
        //   {loading ? "Validating..." : "Scan Barcode"}
        // </button>
      )}

      {/* Error Message */}
      {error && (
        <div class="text-center">
          <h5>
            <div
              class="alert alert-danger"
              role="alert"
              style={{
                backgroundColor: "",
                color: "red",
                marginTop: 10,
                textAlign: "center",
              }}
            >
              {error}
            </div>
          </h5>
        </div>
      )}

      {/* OTP Component */}
      {showValidateModal && isEligible && (
        <div style={{ marginTop: 20 }}>
          {/* <div
            style={{
              position: "fixed",
              top: "20px",
              right: "30px",
              "z-index": "1050",
              width: "500px",
            }}
            class="alert alert-success alert-dismissible fade show"
            role="alert"
          >
            <strong>Congratulations ! </strong>
            <p>Device is eligible for Free Installation.</p>
            <button
              type="button"
              class="close"
              data-dismiss="alert"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div> */}

          <SendOtp
            sendOtpFromNcd={true}
            setCustomerMobile={(mobile) => setCustomerMobile(mobile)}
            show={showValidateModal}
            onCloseModal={() => onRequestSendOtpClose(null)}
            onPressSend={(countryCode, otpRefId) => {
              onRequestSendOtpClose(countryCode, otpRefId);
            }}
          />

          {/* <OtpComponent barcode={barcode} /> */}
        </div>
      )}
      {showValidateOtpModal && (
        <PopPageValidateOtp
          otpReqId={otpReqId}
          sendOtpFromNcd={true}
          userMobileNumber={customerMobile}
          show={showValidateOtpModal}
          countryCode={userCountryCode}
          onCloseModal={() => {
            onRequestValidateOtpModalClose();
          }}
          onPressSend={(isNew, customerData) => {
            onSuccessValidateOtp(isNew, customerData);
          }}
        />
      )}
      {isVerified && isEligible && !success && (
        <div className="container mt-4 ">
          <div className="row justify-content-center">
            <div className="col-md-6 col-lg-5">
              <h4 className="mb-4 text-center">{t("free_install_lbl_form")}</h4>
              <form onSubmit={handleSubmit}>
                {/* Name */}
                <div className="mb-3">
                  {/* <input
                    type="text"
                    className="form-control"
                    value={barcode}
                    readOnly
                  /> */}
                  <label className="form-label">{t("txt_name")}</label>
                  <input
                    type="text"
                    className="form-control"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                  />
                </div>
                {/* Governorate Select */}
                <div className="mb-3">
                  <label className="form-label">
                    {t("free_install_tx_governerate")}
                  </label>
                  <select
                    className="form-select"
                    name="governorate"
                    value={formData.governorate}
                    onChange={handleChange}
                    required
                  >
                    <option value="">{t("free_install_tx_governerate")}</option>
                    {governorates.map((gov, idx) => (
                      <option key={idx} value={gov.name_ar}>
                        {gov.name_ar}
                      </option>
                    ))}
                  </select>
                </div>
                {/* <div className="mb-3">
                  <label className="form-label">{t("txt_street")}</label>
                  <input
                    type="text"
                    className="form-control"
                    name="street"
                    value={formData.street}
                    onChange={handleChange}
                    required
                  />
                </div> */}
                {/* <div className="mb-3">
                  <label className="form-label">{t("txt_area")}</label>
                  <input
                    type="text"
                    className="form-control"
                    name="area"
                    value={formData.area}
                    onChange={handleChange}
                    required
                  />
                </div> */}
                <div className="mb-3">
                  <label className="form-label">
                    {t("free_install_lbl_addr")}
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    name="address"
                    value={formData.address}
                    onChange={handleChange}
                    required
                  />
                </div>
                {/* Invoice Upload */}
                <div className="mb-3">
                  <label className="form-label">
                    {t("free_install_lbl_upload_invoice")}
                  </label>
                  <input
                    type="file"
                    className="form-control"
                    name="invoice"
                    accept=".jpg,.jpeg,.png,.pdf"
                    onChange={handleChange}
                    required
                  />
                </div>

                {/* Preview */}
                {previewUrl && (
                  <div className="mb-3">
                    {/* <label className="form-label">{t("txt_preview")}:</label> */}
                    <div>
                      {fileType === "pdf" ? (
                        <iframe
                          src={previewUrl}
                          title="PDF Preview"
                          width="100%"
                          height="400px"
                          style={{ border: "1px solid #ccc" }}
                        ></iframe>
                      ) : (
                        <img
                          src={previewUrl}
                          alt="Invoice Preview"
                          style={{
                            maxWidth: "100%",
                            maxHeight: "300px",
                            border: "1px solid #ccc",
                          }}
                        />
                      )}
                    </div>
                  </div>
                )}

                {/* Submit Button */}
                <div class="text-center mt-4">
                  <button
                    type="submit"
                    style={{
                      backgroundColor: "var(--button-color)",
                      width: "50%",
                    }}
                    class="btn btn-dark btn-lg  px-5 shadow"
                  >
                    {t("free_install_btn_submit")}
                  </button>
                </div>
                {/* <button type="submit" className="btn btn-primary text-center">
                  {t("free_install_btn_submit")}
                </button> */}
              </form>
            </div>
          </div>
        </div>
      )}
      {success && (
        <div className="container mt-4 ">
          <div className="d-flex align-self-center justify-content-center mt-50 mb-50">
            <CelebrationSvg />
          </div>
          <div>
            <h3 className="cart_thanks_dis text-center">
              {t("thanks")} , {formData.name}
            </h3>
          </div>
        </div>
      )}
    </div>
  );
};

export default BarcodeScanComponent;
